import React, { useState, useEffect } from 'react';
import { format, subDays } from 'date-fns';

interface DateRangePickerProps {
  onDateChange: (startDate: string, endDate: string) => void;
}

const DEFAULT_START_DATE = '2022-01-01';
const DEFAULT_END_DATE = format(new Date(), 'yyyy-MM-dd');

export const DateRangePicker: React.FC<DateRangePickerProps> = ({
  onDateChange,
}) => {
  const [startDate, setStartDate] = useState<string>(DEFAULT_START_DATE);
  const [endDate, setEndDate] = useState<string>(DEFAULT_END_DATE);
  const [appliedStart, setAppliedStart] = useState<string>(DEFAULT_START_DATE);
  const [appliedEnd, setAppliedEnd] = useState<string>(DEFAULT_END_DATE);

  // Apply default dates on mount
  useEffect(() => {
    console.log('DateRangePicker mounted, applying defaults');
    onDateChange(DEFAULT_START_DATE, DEFAULT_END_DATE);
  }, []); // Only on mount

  const applyDates = () => {
    console.log('=== APPLYING DATES ===');
    console.log('Start:', startDate);
    console.log('End:', endDate);
    setAppliedStart(startDate);
    setAppliedEnd(endDate);
    onDateChange(startDate, endDate);
  };

  const quickApply = (start: string, end: string) => {
    console.log('=== QUICK APPLY ===');
    console.log('Start:', start);
    console.log('End:', end);
    setStartDate(start);
    setEndDate(end);
    setAppliedStart(start);
    setAppliedEnd(end);
    onDateChange(start, end);
  };

  const hasChanges = startDate !== appliedStart || endDate !== appliedEnd;

  return (
    <div
      style={{
        display: 'flex',
        gap: '12px',
        alignItems: 'center',
        marginBottom: '20px',
        flexWrap: 'wrap',
      }}
    >
      <label>
        Start Date:
        <input
          type="date"
          value={startDate}
          onChange={(e) => {
            console.log('Start date changed to:', e.target.value);
            setStartDate(e.target.value);
          }}
          style={{
            marginLeft: '8px',
            padding: '6px 12px',
            border: hasChanges ? '2px solid #ff9800' : '1px solid #ddd',
            borderRadius: '4px',
            backgroundColor: hasChanges ? '#fff8e1' : '#fff',
          }}
        />
      </label>
      <label>
        End Date:
        <input
          type="date"
          value={endDate}
          onChange={(e) => {
            console.log('End date changed to:', e.target.value);
            setEndDate(e.target.value);
          }}
          style={{
            marginLeft: '8px',
            padding: '6px 12px',
            border: hasChanges ? '2px solid #ff9800' : '1px solid #ddd',
            borderRadius: '4px',
            backgroundColor: hasChanges ? '#fff8e1' : '#fff',
          }}
        />
      </label>
      
      {/* APPLY BUTTON */}
      <button
        onClick={applyDates}
        style={{
          padding: '8px 20px',
          border: 'none',
          borderRadius: '4px',
          backgroundColor: hasChanges ? '#4CAF50' : '#4CAF50',
          color: '#fff',
          cursor: 'pointer',
          fontWeight: 600,
          fontSize: '14px',
          boxShadow: '0 2px 4px rgba(76,175,80,0.3)',
        }}
      >
        ✓ Apply Dates
      </button>

      <div style={{ borderLeft: '1px solid #ddd', height: '30px', margin: '0 8px' }} />

      {/* Quick Select Buttons */}
      <button
        onClick={() => {
          const today = new Date();
          quickApply(format(subDays(today, 7), 'yyyy-MM-dd'), format(today, 'yyyy-MM-dd'));
        }}
        style={{
          padding: '6px 12px',
          border: '1px solid #ddd',
          borderRadius: '4px',
          backgroundColor: '#f5f5f5',
          cursor: 'pointer',
        }}
      >
        Last 7 days
      </button>
      <button
        onClick={() => {
          const today = new Date();
          quickApply(format(subDays(today, 30), 'yyyy-MM-dd'), format(today, 'yyyy-MM-dd'));
        }}
        style={{
          padding: '6px 12px',
          border: '1px solid #ddd',
          borderRadius: '4px',
          backgroundColor: '#f5f5f5',
          cursor: 'pointer',
        }}
      >
        Last 30 days
      </button>
      <button
        onClick={() => {
          const today = new Date();
          quickApply(format(subDays(today, 90), 'yyyy-MM-dd'), format(today, 'yyyy-MM-dd'));
        }}
        style={{
          padding: '6px 12px',
          border: '1px solid #ddd',
          borderRadius: '4px',
          backgroundColor: '#f5f5f5',
          cursor: 'pointer',
        }}
      >
        Last 90 days
      </button>
      <button
        onClick={() => quickApply(DEFAULT_START_DATE, DEFAULT_END_DATE)}
        style={{
          padding: '6px 12px',
          border: '1px solid #2196F3',
          borderRadius: '4px',
          backgroundColor: '#2196F320',
          color: '#2196F3',
          cursor: 'pointer',
          fontWeight: 500,
        }}
      >
        Full Year 2025
      </button>
      <button
        onClick={() => quickApply('2022-01-01', format(new Date(), 'yyyy-MM-dd'))}
        style={{
          padding: '6px 12px',
          border: '1px solid #9C27B0',
          borderRadius: '4px',
          backgroundColor: '#9C27B020',
          color: '#9C27B0',
          cursor: 'pointer',
          fontWeight: 500,
        }}
      >
        All Time
      </button>

    </div>
  );
};
